import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Exploreindianpanindia() {



  const cardData = {
    keyword: " Explore India / Pan India Cab Booking Services ",


"headingDescription": "Royal Route Cab offers reliable Explore India and Pan India cab booking services, providing safe, comfortable, and affordable long-distance travel across all major cities, states, and tourist destinations in India. Whether you are planning a family vacation, business tour, pilgrimage journey, or multi-city road trip, our professional drivers and well-maintained vehicles ensure a smooth and stress-free travel experience throughout India. We offer flexible travel options including one-way drops, round trips, multi-day rentals, and customized itineraries based on your travel plan. Our fleet includes sedans, SUVs, luxury cars, and Tempo Travellers suitable for solo travelers, families, and large groups. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted partner for Pan India cab services.",

"topPlaces": [
  {
    "title": "Delhi",
    "description": "Delhi is India’s capital city and one of the most important travel hubs in the country. It is known for historical monuments like India Gate, Red Fort, and Qutub Minar, along with modern attractions, shopping markets, and political landmarks. Pan India cab services frequently connect Delhi with major cities like Agra, Jaipur, and Chandigarh for tourism and business travel."
  },
  {
    "title": "Jaipur",
    "description": "Jaipur, also known as the Pink City, is famous for its royal palaces, forts, and rich cultural heritage. Key attractions include Hawa Mahal, Amber Fort, and City Palace. It is a major destination for road trips from Delhi and other North Indian cities, making it a key part of Pan India cab routes."
  },
  {
    "title": "Agra",
    "description": "Agra is home to the world-famous Taj Mahal, one of the Seven Wonders of the World. It also features historical sites like Agra Fort and Fatehpur Sikri. Cab services are widely used for same-day and multi-day trips from Delhi and Jaipur under Pan India travel packages."
  },
  {
    "title": "Varanasi",
    "description": "Varanasi is one of the oldest living cities in the world, known for its spiritual significance on the banks of the Ganga River. Visitors come for Ganga Aarti, temples, and cultural experiences. It is a major destination in Pan India pilgrimage cab routes."
  },
  {
    "title": "Mumbai",
    "description": "Mumbai is India’s financial capital and a major hub for long-distance cab travel across India. It connects to destinations like Goa, Pune, Nashik, and Ahmedabad, making it an important starting point for Pan India cab bookings."
  },
  {
    "title": "Goa",
    "description": "Goa is India’s most popular beach destination known for nightlife, beaches, water sports, and Portuguese heritage. It is a top choice for long road trips and outstation cab services from Mumbai, Pune, and Bangalore."
  },
  {
    "title": "Udaipur",
    "description": "Udaipur, known as the City of Lakes, is famous for its royal palaces, scenic lakes, and romantic atmosphere. It is a popular destination for luxury road trips and wedding travel packages in India."
  },
  {
    "title": "Amritsar",
    "description": "Amritsar is home to the Golden Temple, one of the most important spiritual sites in India. It attracts pilgrims and tourists from across the country and is frequently included in Pan India cab pilgrimage routes."
  },
  {
    "title": "Rishikesh",
    "description": "Rishikesh is known as the Yoga Capital of the World and is famous for adventure activities like river rafting, trekking, and spiritual retreats. It is a popular destination for road trips and wellness travel in North India."
  },
  {
    "title": "Bangalore",
    "description": "Bangalore is India’s IT hub and a major metro city with strong connectivity to South Indian destinations like Mysore, Coorg, and Ooty. It is widely used as a base for long-distance cab travel across South India."
  }
],






services: [
  {
    name: "Pan India Cab Service",
    description: "Pan India cab service offers seamless travel solutions across multiple cities and states in India. This service is ideal for long-distance journeys, business travel, and tourism. Well-maintained vehicles and experienced drivers ensure safety and comfort. Flexible booking options and nationwide coverage make it highly convenient. It guarantees a reliable travel experience across India."
  },
  {
    name: "All India Taxi Service",
    description: "All India taxi service provides reliable transportation across the country for both personal and corporate travel. This service connects major cities, towns, and tourist destinations. Professional drivers and quality vehicles ensure smooth journeys. It ensures a comfortable and dependable travel experience."
  },
  {
    name: "Outstation Cab India",
    description: "Outstation cab India offers long-distance travel to cities and tourist destinations across the country. This service is ideal for family vacations, pilgrimages, and business trips. Vehicles are maintained for highway performance. It ensures a safe and comfortable journey."
  },
  {
    name: "Intercity Cab Service India",
    description: "Intercity cab service India provides convenient travel between cities with flexible pickup and drop options. This service is suitable for business travel and personal trips. Customers can choose from one way and round trip options. It ensures efficient and smooth travel."
  },
  {
    name: "Long Distance Taxi India",
    description: "Long distance taxi India offers reliable transportation for extended travel across states. This service is ideal for road trips, corporate travel, and tourism. Comfortable vehicles and professional drivers enhance the journey. It guarantees a hassle-free experience."
  },
  {
    name: "Cab Booking Across India",
    description: "Cab booking across India allows customers to reserve rides easily from any location to any destination. This service offers flexible travel options and instant confirmation. Suitable for local, intercity, and long-distance travel. It simplifies travel planning."
  },
  {
    name: "Taxi Service Pan India",
    description: "Taxi service pan India ensures nationwide availability of cabs for various travel needs. This service is ideal for business, tourism, and daily travel across cities. Well-maintained vehicles and trained drivers ensure safety. It guarantees a reliable journey."
  },
  {
    name: "One Way Cab India",
    description: "One way cab India offers cost-effective travel for single-side journeys without return charges. This service is ideal for airport transfers and intercity travel. Flexible pickup options enhance convenience. It ensures economical and smooth travel."
  },
  {
    name: "Round Trip Taxi India",
    description: "Round trip taxi India provides complete travel solutions for onward and return journeys. This service includes flexible schedules and waiting options. Ideal for vacations and business trips. It ensures convenience and comfort."
  },
  {
    name: "India Tour Cab Service",
    description: "India tour cab service offers customized travel packages for exploring tourist destinations across the country. This service is ideal for family trips, group tours, and sightseeing. Experienced drivers ensure safe travel. It guarantees a memorable travel experience."
  },
  {
    name: "Cab for India Travel",
    description: "Cab for India travel provides flexible and reliable transportation for exploring multiple cities and regions. This service is suitable for tourists and business travelers. Comfortable vehicles and customized routes enhance the journey. It ensures a smooth travel experience."
  },
  {
    name: "Nationwide Taxi Booking",
    description: "Nationwide taxi booking allows customers to book cabs across India with ease. This service offers instant confirmation, flexible options, and transparent pricing. Suitable for all types of travel. It simplifies nationwide travel planning."
  },
  {
    name: "Affordable Pan India Cab",
    description: "Affordable pan India cab offers budget-friendly travel options across the country. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical long-distance travel."
  },
  {
    name: "Best All India Taxi Service",
    description: "Best all India taxi service ensures premium travel experience with top-quality vehicles and professional drivers. This service focuses on comfort, safety, and reliability. Suitable for all travel needs across India. It guarantees a trusted journey."
  },
  {
    name: "Corporate Cab India",
    description: "Corporate cab India provides professional travel solutions for businesses operating across multiple cities. This service includes employee transport, executive travel, and business trips. Reliable drivers and well-maintained vehicles ensure punctuality. It ensures efficient corporate mobility."
  },
  {
    name: "Reliable India Cab Service",
    description: "Reliable India cab service ensures consistent and dependable transportation across the country. This service focuses on safety, punctuality, and customer satisfaction. Suitable for personal and business travel. It guarantees a smooth and stress-free experience."
  }
],

tableData: [
  ["Pan India Cab Service", "All India Taxi Service"],
  ["Outstation Cab India", "Intercity Cab Service India"],
  ["Long Distance Taxi India", "Cab Booking Across India"],
  ["Taxi Service Pan India", "One Way Cab India"],
  ["Round Trip Taxi India", "India Tour Cab Service"],
  ["Cab for India Travel", "Nationwide Taxi Booking"],
  ["Affordable Pan India Cab", "Best All India Taxi Service"],
  ["Corporate Cab India", "Reliable India Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Pan India Cab Booking Services",
    WhyChoosedescription: "Royal Route Cabs offers reliable cab booking services across India, covering major cities, tourist destinations, and remote locations."
  },
  {
    WhyChooseheading: "Wide Route Coverage Across India",
    WhyChoosedescription: "Travel anywhere in India with our extensive network connecting cities, hill stations, pilgrimage destinations, and business hubs."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are skilled in long-distance and interstate travel, ensuring safe, smooth, and comfortable journeys."
  },
  {
    WhyChooseheading: "Flexible Travel Plans & Packages",
    WhyChoosedescription: "We offer one-way, round-trip, and multi-day travel packages customized as per your itinerary and budget."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing with tolls, driver allowance, and all charges included with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Nationwide Availability",
    WhyChoosedescription: "Our Pan India cab service operates 24/7, allowing you to travel anytime across cities and states."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted All-India Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable Pan India cab bookings with professional service and consistent quality."
  }
]

};

const faqData = [
  { question: "Do you provide cab services across India?", answer: "Yes, Royal Route Cabs offers Pan India cab booking services covering major cities and destinations." },
  { question: "Can I travel interstate with your cab service?", answer: "Yes, we provide interstate travel across India with proper permits and experienced drivers." },
  { question: "What types of travel options are available?", answer: "We offer one-way, round-trip, and multi-day cab booking options." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Pan India cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Can I customize my travel plan?", answer: "Yes, we provide fully customizable travel packages based on your itinerary." },
  { question: "Do you provide pickup from home?", answer: "Yes, we offer doorstep pickup from any location across India." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance and multi-day trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback: "Pan India cab service with Royal Route Cabs was extremely reliable. The long-distance travel was well-managed with a comfortable and safe ride experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Sharma",
    feedback: "Excellent experience with pan India travel. The service was consistent across states, the driver was professional, and the journey felt smooth throughout.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pan India Cab Booking Services",
  "image": "https://www.royalroutecabs.com/assets/images/pan-india-cab-service.jpg", // replace if needed
  "description": "Book Pan India cab service with Royal Route Cabs for safe, reliable, and affordable long-distance travel across India. Available for one-way, round-trip, intercity, and corporate travel with sedan, SUV, Innova, and luxury vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/pan-india-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pan India Cab Booking Services | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Pan India cab service with Royal Route Cabs. Reliable intercity and long-distance taxi service across India with affordable fares, safe drivers, and 24x7 availability."
  />

  <meta
    name="keywords"
    content="pan india cab service, all india taxi service, outstation cab india, intercity cab service india, long distance taxi india, cab booking across india, taxi service pan india, one way cab india, round trip taxi india, india tour cab service, cab for india travel, nationwide taxi booking, affordable pan india cab, best all india taxi service, corporate cab india, reliable india cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Exploreindianpanindia;